import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "router/types";
import LandingPageHeader from "pages/LandingPageHeader";
import LandingPageMainSection from "pages/LandingPageMainSection/LandingPageMainSection";
import LandingPageFooter from "pages/LandingPageFooter";
const Main = () => {
  const navigate = useNavigate();
  return (
    <>
      <Grid container rowSpacing={2}>
        <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
          <LandingPageHeader />
        </Grid>
        <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
          <LandingPageMainSection />
        </Grid>
        <Grid
          item
          md={12}
          lg={12}
          xl={12}
          sm={12}
          xs={12}
          paddingTop={"0px !important"}
        >
          <LandingPageFooter />
        </Grid>
      </Grid>
    </>
  );
};

export default Main;
